import db from 'utils/localstorage'

export default {
  namespaced: true,
  state: {
    dicts: db.get('WEB_DICTS')
  },
  mutations: {
    setDicts (state, val) {
      db.save('WEB_DICTS', val)
      state.dicts = val
    }
  }
}
